import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ApiService } from '../services/api/api.service';
import { LightAccountService } from '../services/light-account/light-account.service';
import { PermissionsService } from '../services/permissions/permissions.service';

/**
 * Comptes légers (page d'inscription personnalisée) : jamais de BO classique.
 * Posé sur la route de l'AppLayout — toute page privée renvoie un compte léger
 * vers la marketplace des pages perso.
 *
 * Coût nul pour un compte classique : décision sur le /me en cache
 * (localStorage currentUser) ; un seul appel /me si le cache est absent.
 */
export const lightAccountGuard: CanActivateFn = () => {
  if (!localStorage.getItem('access_token')) return true; // AuthGuard s'en charge

  const router = inject(Router);
  const lightAccount = inject(LightAccountService);

  const cached = lightAccount.cachedUser();
  if (cached) {
    return lightAccount.isLight(cached) ? router.parseUrl('/marketplace') : true;
  }

  const api = inject(ApiService);
  const permissions = inject(PermissionsService);
  return api.getMe().pipe(
    map((user: any) => {
      permissions.setCurrentUser(user);
      return lightAccount.isLight(user) ? router.parseUrl('/marketplace') : true;
    }),
    // En cas de doute on laisse passer : le back restreint le JWT léger.
    catchError(() => of(true)),
  );
};
